// from general.js
/* global isMobileView qsParam */

import { setup } from '../common/readMoreLink.js';


$(document).ready(function () {
    // Expand and close the match offer info
    $('body').on('click', '.js-match-trigger', function (e) {
        e.preventDefault();
        $('.js-match-expanded').toggleClass('active');
        $('.js-match-trigger').toggleClass('active');
    });

    // Expanded materials section
    //
    // Note: these same links control whether or not we show replacements-data.
    // That functionality relies on data from an on-mount AJAX call, so it lives elsewhere.
    // See resourceReplacementsMain.js and its dependencies.

    // Show rows that are hidden in the materials section.
    // All rows that are hidden on load have the class 'js-expanded-donation-section', and this shows all of them
    // Also hides the trigger button itself and then shows the button to close donations
    $('.js-expand-donations-trigger').on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $('.js-expanded-donation-section').show();
        $('.js-close-breakdown').addClass('active');
    });

    // Hide the expanded materials section
    $('.js-close-breakdown').on('click', function (e) {
        e.preventDefault();
        $('.js-expanded-donation-section').hide();
        $('.js-expand-donations-trigger').addClass('active');
        $(this).removeClass('active');
    });
    // /Expanded materials section

    // Show 'still needed' calculations in material section
    $('.js-calculator-trigger').on('click', function (e) {
        e.preventDefault();
        $('.js-calculator-trigger').toggleClass('active');
        $('.js-hide-calculator').toggleClass('active');
        $('.js-still-needed-expanded-row').show();
    });

    // Hide 'still needed' calculation section in material section
    // Makes sure to return donation detail and match detail of calculation section to original collapsed versions
    $('.js-hide-calculator').on('click', function (e) {
        e.preventDefault();
        $('.js-calculator-trigger').toggleClass('active');
        $('.js-hide-calculator').toggleClass('active');
        $('.js-still-needed-expanded-row').hide();
        $('.js-match-full-donation').hide();
        $('.js-match-detail').removeClass('active');
        $('.js-donation-detail').removeClass('active');
        $('.js-expand-detail').removeClass('icon-navigatedown').addClass('icon-navigateright');
    });

    // Expands match offer detail in calculation section (to see amount partner gave that would be allocated for project cost vs DonorsChoose overhead
    $('.js-expand-match-detail').on('click', function (e) {
        $('.js-match-detail').toggleClass('active');
        if ($('.js-match-detail').hasClass('active')) {
            $(this).find('.js-expand-detail').removeClass('icon-navigateright').addClass('icon-navigatedown');
            $('.js-match-full-donation').hide();
        } else {
            $(this).find('.js-expand-detail').removeClass('icon-navigatedown').addClass('icon-navigateright');
            $('.js-match-full-donation').show();
        }
    });

    // Expands donation detail in calculation section (donors giving to project costs vs DonorsChoose overhead)
    $('.js-expand-donation-detail').on('click', function (e) {
        $('.js-donation-detail').toggleClass('active');
        if ($('.js-donation-detail').hasClass('active')) {
            $(this).find('.js-expand-detail').removeClass('icon-navigateright').addClass('icon-navigatedown');
            $('.js-donors-full-donation').hide();
        } else {
            $(this).find('.js-expand-detail').removeClass('icon-navigatedown').addClass('icon-navigateright');
            $('.js-donors-full-donation').show();
        }
    });

    // Expand and close mobile materials section
    $('.js-expand-mobile-materials-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        const $svg = $(this).find('svg');
        if ($(this).hasClass('active')) {
            $svg.attr('class', 'icon icon-navigateup').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigateup"></use>');
        } else {
            $svg.attr('class', 'icon icon-navigatedown').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigatedown"></use>');
        }
        $('.js-expand-mobile-materials').toggleClass('active');
        $('.js-materials-wrapper').toggleClass('active');
    });

    function expandMaterials() {
        $('.js-expand-mobile-materials.expand-mobile-materials').addClass('active');
        const $svg = $('.js-expand-mobile-materials-toggle').find('svg');
        $svg.attr('class', 'icon icon-navigateup').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigateup"></use>');
    }

    expandMaterials();

    // Expand and close mobile activity section
    $('.js-expand-mobile-activity-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        const $svg = $(this).find('svg');
        if ($(this).hasClass('active')) {
            $svg.attr('class', 'icon icon-navigateup').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigateup"></use>');
        } else {
            $svg.attr('class', 'icon icon-navigatedown').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigatedown"></use>');
        }
        $('.js-expand-mobile-activity').toggleClass('active');
        $('.js-project-activity').toggleClass('active');
    });

    // Expand essay in mobile when user clicks "Read More"
    setup('.js-read-more', '.js-project-essay');

    // if 3 or fewer materials in list, show more
    if ($('.itemName').length < 4) {
        $('.js-expand-donations-trigger').trigger('click');
    }

    if (isMobileView() && (qsParam.lightbox != null || location.hash.indexOf('#pm') === 0)) {
        $('.js-expand-mobile-activity-toggle').trigger('click');
    }
});
